import e from "dayjs";
import t from "dayjs/plugin/utc";
// src/design/forms/datepicker/utilities/utc.ts
e.extend(t);
var n = "YYYY-MM-DD", r = (t) => t && e.utc(t).local().format(n), i = (t) => t && e(t).utc().format();
export { r as toLocalDateFromUtc, i as toUtcFromLocalDate };

//# sourceMappingURL=utc.js.map